import { ResourceLanguage } from 'i18next'
import { Translation } from '../translation'

export const english: Translation & ResourceLanguage = {
    pageTitles: {
        coacheeLogin: 'Log into your account',
    },
    titles: {
        logIn: 'Sign in to Sama',
    },
    subTitles: {
        welcome: 'To get started please click continue.',
        appDownload: 'or download the app',
    },
    buttons: {
        continue: 'Continue',
    },
}
